module.exports = __webpack_public_path__ + "static/media/esporte-content.7cd1c149.jpg";